import styled from 'styled-components';
import { Container } from '~/components/layout';

export const ExpanderItem = styled(Container)`
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid rgba(11, 31, 28, 0.16);
  margin-bottom: 16px;
`;
